import type { FunctionComponent } from 'react';

import Flex from '../../generic/Flex';

import './PackageInventoryFilters.less';

/**
 * PackageInventoryFilters renders the sidebar which contains all
 * of the various filter panels.
 */
const PackageInventoryFilters: FunctionComponent = ({ children }) => (
  <div className="package-inventory__filters">
    <Flex gap="16px" direction="column" align="stretch">
      {children}
    </Flex>
  </div>
);

export default PackageInventoryFilters;
